import React, { createContext, useState, useContext, useEffect } from "react";

const LoggedInUserInfoContext = createContext();
const LoggedInUserInfoActionsContext = createContext();

export const useLoggedInUserInfoContext = () =>
  useContext(LoggedInUserInfoContext);
export const useLoggedInUserInfoActionsContext = () =>
  useContext(LoggedInUserInfoActionsContext);

export const LoggedInUserInfoProvider = ({ children }) => {
  const [loggedInuserInfo, setLoggedInUserInfo] = useState("");

  const updateLoggedInUserInfo = (userInfo) => {
    setLoggedInUserInfo(userInfo);
  };

  return (
    <LoggedInUserInfoContext.Provider value={loggedInuserInfo}>
      <LoggedInUserInfoActionsContext.Provider value={updateLoggedInUserInfo}>
        {children}
      </LoggedInUserInfoActionsContext.Provider>
    </LoggedInUserInfoContext.Provider>
  );
};
